import React, { useEffect, useState, useRef, useCallback } from "react";
import classes from "./SavingsWithdrawals.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
import { SquarePen, Trash2, Printer, X, Upload } from "lucide-react";
import api from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Swal from 'sweetalert2';
import { Spinner } from "react-bootstrap";
import Select from "react-select";

// ✅ Import your standalone UploadExcelModal3 component
import UploadExcelModal3 from "./UploadExcelModal3";


// --- Child Manual Modal Component ---
const SavingsWithdrawalModal = ({ isOpen,
    onClose,
    onSaveSuccess,
    mode="create",
    requestData=null }) => {
  const [member, setMember] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [balance, setBalance] = useState(0);
  const [date, setDate] = useState("");
  const [currency, setCurrency] = useState("");
  const [description, setDescription] = useState("");
  const [modeOfPayment, setModeOfPayment] = useState("");
  const [bankAccount, setBankAccount] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [reference, setReference] = useState("");
  const [file, setFile] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const toastShown = useRef(false);

  const [membersList, setMembersList] = useState([]);
  const [memberSavingsData, setMemberSavingsData] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [companyId, setCompanyId] = useState(null);
  const [loadingDropdowns, setLoadingDropdowns] = useState(true);
  const [fetchingMemberSavings, setFetchingMemberSavings] = useState(false);

  const [rows, setRows] = useState([
    { id: 1, accountName: "", accountCode: "", amount: "", direction: "DR" }
  ]);

  // --- Reset function (used both on save and on open) ---
  const handleReset = () => {
    setMember("");
    setPaymentType("");
    setBalance(0);
    setDate("");
    setCurrency("");
    setDescription("");
    setModeOfPayment("");
    setBankAccount("");
    setTotalAmount("");
    setReference("");
    setFile(null);
    setRows([{ id: 1, accountName: "", accountCode: "", amount: "", direction: "DR" }]);
    toastShown.current = false;
  };

  // --- Reset the form every time the modal opens ---
  useEffect(() => {
    if (isOpen) {
      handleReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(()=>{

    if(
        isOpen &&
        mode==="approve" &&
        requestData
    ){

        setMember(requestData.member_id);

        setPaymentType(requestData.savings_id);

        setDate(requestData.transaction_date);

        setDescription(requestData.description);

        setTotalAmount(requestData.amount);

        setReference(requestData.reference);

    }

},[
    isOpen,
    mode,
    requestData
]);

  // --- Fetch dropdown data when modal opens ---
  useEffect(() => {
    const fetchDropdownData = async () => {
      setLoadingDropdowns(true);
      try {
        const compInfo = localStorage.getItem('companyInfo');
        if (compInfo) {
          try {
            const parsedInfo = JSON.parse(compInfo);
            setCompanyId(parsedInfo.id);
          } catch(e) {}
        }

        const [membersRes, currenciesRes, banksRes] = await Promise.all([
          api.get('v1/member/with_savings'),
          api.get('/v1/fetch-all-currencies'),
          api.get('/v1/bank-accounts')
        ]);

        if (membersRes.data?.status) setMembersList(membersRes.data.data || []);
        
        if (currenciesRes.data?.status) {
          const currencyData = currenciesRes.data.data || [];
          setCurrencies(currencyData);
          const ngnCurrency = currencyData.find(c => c.code === "NGN");
          if (ngnCurrency) setCurrency(ngnCurrency.id);
        }

        if (banksRes.data?.status) setBankAccounts(banksRes.data.data || []);
      } catch (error) {
        console.error("Failed to fetch dropdown data:", error);
      } finally {
        setLoadingDropdowns(false);
      }
    };
    if (isOpen) fetchDropdownData();
  }, [isOpen]);

  // --- Fetch member savings when member changes ---
  useEffect(() => {
    const fetchMemberSavings = async () => {
      if (!member || !companyId) {
        setMemberSavingsData([]);
        setPaymentType(""); 
        setBalance(0);
        return;
      }

      setFetchingMemberSavings(true);
      try {
        const res = await api.get('/v1/fetch_member_savings', {
          params: {
            member_id: member,
            company_id: companyId
          }
        });

        if (res.data?.status && Array.isArray(res.data.data)) {
          setMemberSavingsData(res.data.data);
        } else {
          setMemberSavingsData([]);
        }
      } catch (error) {
        console.error("Error fetching member savings:", error);
        setMemberSavingsData([]);
      } finally {
        setFetchingMemberSavings(false);
      }
    };
    fetchMemberSavings();
  }, [member, companyId]);

  // --- Update balance when paymentType changes ---
  useEffect(() => {
    if (!member || !paymentType) {
      setBalance(0);
      return;
    }
    
    const selectedSavings = memberSavingsData.find(
      item => item.id == paymentType
    );
    
    if (selectedSavings) {
      setBalance(Number(selectedSavings.balance || selectedSavings.current_balance || 0));
    } else {
      setBalance(0);
    }
  }, [paymentType, memberSavingsData, member]);

  // Row 1: Savings Liability GL – direction "Dr"
  useEffect(() => {
    setRows(prev => {
      let newRows = [...prev];
      if (!newRows[0]) newRows[0] = { id: 1, accountName: "", accountCode: "", amount: "", direction: "DR" };

      if (paymentType && memberSavingsData.length > 0) {
        const selectedSavings = memberSavingsData.find(item => item.id == paymentType);
        if (selectedSavings?.type?.savings_liability_gl) {
          const gl = selectedSavings.type.savings_liability_gl;
          newRows[0] = { ...newRows[0], accountName: gl.gl_name || "", accountCode: gl.gl_code || "", direction: "DR" };
        } else {
          newRows[0] = { ...newRows[0], accountName: "", accountCode: "", direction: "DR" };
        }
      } else {
        newRows[0] = { ...newRows[0], accountName: "", accountCode: "", direction: "DR" };
      }
      return newRows;
    });
  }, [paymentType, memberSavingsData, member]);

  // Row 2: Bank Account – direction "Cr"
  useEffect(() => {
    setRows(prev => {
      let newRows = [...prev];
      if (bankAccount && bankAccounts.length > 0) {
        if (!newRows[1]) newRows[1] = { id: 2, accountName: "", accountCode: "", amount: "", direction: "CR" };
        
        const selectedBank = bankAccounts.find(item => item.id == bankAccount);
        if (selectedBank) {
          newRows[1] = { ...newRows[1], accountName: selectedBank.gl_name || selectedBank.account_name || "", accountCode: selectedBank.gl_code || "", direction: "CR" };
          if (totalAmount) newRows[1].amount = String(totalAmount);
        }
      } else {
        newRows = newRows.filter((_, i) => i !== 1);
      }
      return newRows;
    });
  }, [bankAccount, bankAccounts, totalAmount]);

  // Update both rows' amount when totalAmount changes
  useEffect(() => {
    setRows(prev => {
      const newRows = [...prev];
      const amountVal = totalAmount ? String(totalAmount) : "";
      if (newRows[0]) newRows[0] = { ...newRows[0], amount: amountVal };
      if (newRows[1]) newRows[1] = { ...newRows[1], amount: amountVal };
      return newRows;
    });
  }, [totalAmount]);

  const numericBalance = Number(balance) || 0;
  const numericAmount = Number(totalAmount) || 0;
  const isOverBalance = numericAmount > numericBalance;

  // Insufficient balance toast
  useEffect(() => {
    if (numericBalance > 0 && numericAmount > numericBalance) {
      if (!toastShown.current) {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        Toast.fire({
          icon: 'error',
          title: 'Insufficient balance',
          text: `Available balance is ${numericBalance.toLocaleString('en-NG', { minimumFractionDigits: 2 })}.`
        });
        toastShown.current = true;
      }
    } else {
      toastShown.current = false;
    }
  }, [numericAmount, numericBalance]);

  // --- Submit handler ---
  const handleSubmit = async () => {
    if (!companyId) {
      Swal.fire({ icon: 'error', title: 'Error', text: 'Company ID is missing. Please refresh the page.' });
      return;
    }
    if (!member) { Swal.fire({ icon: 'error', title: 'Error', text: 'Member Name is required.' }); return; }
    if (!paymentType) { Swal.fire({ icon: 'error', title: 'Error', text: 'Savings type is required.' }); return; }
    if (!date) { Swal.fire({ icon: 'error', title: 'Error', text: 'Date is required.' }); return; }
    if (!totalAmount || Number(totalAmount) <= 0) { Swal.fire({ icon: 'error', title: 'Error', text: 'Total Amount must be greater than 0.' }); return; }
    if (!bankAccount) { Swal.fire({ icon: 'error', title: 'Error', text: 'Bank Account is required.' }); return; }
    if (!description) { Swal.fire({ icon: 'error', title: 'Error', text: 'Description is required.' }); return; }

    if (isOverBalance) {
      Swal.fire({ icon: 'error', title: 'Insufficient Balance', text: `Withdrawal amount exceeds available balance of ${numericBalance.toLocaleString()}.` });
      return;
    }

    setIsSaving(true);
    try {
      const payload = {
  company_id: Number(companyId),
  amount: Number(totalAmount),
  transaction_date: date,
  account_id: Number(paymentType),
  bank: Number(bankAccount),
  member_id: Number(member),
  description: description,

  // Only send request_id when approving
  ...(mode === "approve" && requestData?.id
    ? { request_id: requestData.id }
    : {}),
};

      const response = await api.post('/v1/customer/savings-withdrawal', payload);

     if (response.status === 200 || response.status === 201) {
  Swal.fire({
    icon: "success",
    title: "Success",
    text:
      response.data?.message ||
      "Savings withdrawal processed successfully.",
  });

  handleReset();

  if (onSaveSuccess) {
    onSaveSuccess();
  }

  onClose();
}
    } catch (error) {
      console.error("API Error:", error);
      let errorMessage = 'Failed to process savings withdrawal. Please try again.';
      if (error.response?.data?.errors) {
        const errors = error.response.data.errors;
        errorMessage = Object.values(errors).flat().join('<br/>');
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      Swal.fire({
        icon: 'error',
        title: 'Save Failed',
        html: errorMessage
      });
    } finally {
      setIsSaving(false);
    }
  };

  const removeRow = (index) => {
    if (rows.length > 1) {
      const updatedRows = rows.filter((_, i) => i !== index);
      setRows(updatedRows);
    }
  };

  if (!isOpen) return null;

  const totalDebit = rows[0] ? (parseFloat(rows[0].amount) || 0) : 0;
  const totalCredit = rows[1] ? (parseFloat(rows[1].amount) || 0) : 0;

  const handleRowChange = (index, field, value) => {
    const updatedRows = rows.map((row, i) => (i === index ? { ...row, [field]: value } : row));
    setRows(updatedRows);
  };

  return (
    <div className={classes.modalOverlay} onClick={onClose}>
      <div className={classes.customModal} onClick={(e) => e.stopPropagation()}>
        <div className={classes.modalContent}>
          <div className={classes.modalHeader}>
            <h5 className={classes.modalTitle}>{
              mode==="approve"
              ?"Approve Withdrawal Request"
              :"Savings Withdrawal"
              }</h5>
            <button type="button" className={classes.modalCloseBtn} onClick={onClose}>
              <X size={20} />
            </button>
          </div>

          <div className={classes.modalBody}>
            <div className={classes.modalGrid}>
              <div className={classes.modalRow3}>
                <div className={classes.modalCol}>
                  <label>Member Name</label>
                  <Select
                  isDisabled={mode==="approve"}
  options={membersList.map((m) => ({
    value: m.id,
    label: m.name,
  }))}
  value={
    membersList
      .map((m) => ({
        value: m.id,
        label: m.name,
      }))
      .find((option) => option.value === member) || null
  }
  onChange={(selected) => setMember(selected?.value || "")}
  placeholder="Select Member"
  isLoading={loadingDropdowns}
  isSearchable
  isClearable
  styles={{
    control: (provided) => ({
      ...provided,
      minHeight: "35px",
      height: "35px",
      borderRadius: "6px",
      borderColor: "#d1d5db",
      fontSize: 13,
      boxShadow: "none",
      "&:hover": {
        borderColor: "#6b7280",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "35px",
      padding: "0 8px",
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
      fontSize: 13,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "35px",
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: "4px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 99999,
      fontSize: 13,
    }),
  }}
/>
                </div>

                <div className={classes.modalCol}>
                  <label>Select savings type</label>
                  <select className={classes.modalInput} disabled={mode==="approve"} value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
                    <option value="">{!member ? "Select Member first" : fetchingMemberSavings ? "Loading savings..." : "Select savings type"}</option>
                    {member && !fetchingMemberSavings && 
                      memberSavingsData.map(p => (
                        <option key={p.id} value={p.id}>
                          {p.type?.product_name || p.type?.product_code || `Savings #${p.id}`}
                        </option>
                      ))
                    }
                  </select>

                  {/* Balance display – only when both selections are made */}
                  {member && paymentType && (
                    <div className={classes.balanceDisplay}>
                      <span>Available Balance:</span>
                      <strong>₦{balance.toLocaleString('en-NG', { minimumFractionDigits: 2 })}</strong>
                    </div>
                  )}
                </div>

                <div className={classes.modalCol}>
                  <label>Date</label>
                  <input  type="date" className={classes.modalInput} value={date} onChange={(e) => setDate(e.target.value)} />
                </div>
              </div>

              <div className={classes.modalRow3}>
                <div className={classes.modalCol}>
                  <label>Currency</label>
                  <select className={classes.modalInput} value={currency} onChange={(e) => setCurrency(e.target.value)}>
                    <option value="">Select Currency</option>
                    {loadingDropdowns ? <option>Loading...</option> : 
                      currencies.map(c => <option key={c.id} value={c.id}>{c.code || c.name}</option>)}
                  </select>
                </div>
                <div className={classes.modalCol}>
                  <label>Description</label>
                  <input disabled={mode==="approve"} type="text" className={classes.modalInput} placeholder="Enter description" value={description} onChange={(e) => setDescription(e.target.value)} />
                </div>
                <div className={classes.modalCol}>
                  <label>Mode of Payment</label>
                  <select className={classes.modalInputNoArrow} value={modeOfPayment} onChange={(e) => setModeOfPayment(e.target.value)}>
                    <option value="">Select payment mode...</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Cheque">Cheque</option>
                    <option value="Teller">Teller</option>
                    <option value="Cash">Cash</option>
                  </select>
                </div>
              </div>

              <div className={classes.modalRow3}>
                <div className={classes.modalCol}>
                  <label>Bank Account</label>
                  <select className={classes.modalInput} value={bankAccount} onChange={(e) => setBankAccount(e.target.value)}>
                    <option value="">Search or select debit account...</option>
                    {loadingDropdowns ? <option>Loading...</option> : 
                      bankAccounts.map(b => <option key={b.id} value={b.id}>{b.gl_name || b.name || b.account_name}</option>)}
                  </select>
                </div>
                <div className={classes.modalCol}>
                  <label>Total Amount</label>
                  <input
                  disabled={mode==="approve"} 
                    type="number" 
                    className={classes.modalInput} 
                    placeholder="Enter Amount" 
                    value={totalAmount} 
                    onChange={(e) => setTotalAmount(e.target.value)} 
                  />
                </div>
                <div className={classes.modalCol}>
                  <label>Reference/ Savings No.</label>
                  <input type="text" className={classes.modalInput} placeholder="Enter reference number" value={reference} onChange={(e) => setReference(e.target.value)} />
                </div>
              </div>

              <div className={classes.modalTableWrap}>
                <table className={classes.modalTable}>
                  <thead>
                    <tr>
                      {/* <th style={{width: '30px'}}>#</th> */}
                      <th>Account Name</th>
                      <th style={{width: '160px'}}>Account Code</th>
                      <th style={{width: '100px'}}>Direction</th>
                      <th style={{width: '160px'}}>Amount</th>
                      <th style={{width: '20px'}}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={row.id}>
                        {/* <td style={{textAlign: 'center', fontWeight: 600, fontSize: '13px'}}>{index + 1}</td> */}
                        <td>
                          <input
                            type="text"
                            placeholder="Search or type account..."
                            value={row.accountName}
                            onChange={(e) => handleRowChange(index, 'accountName', e.target.value)}
                            readOnly={true} 
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            placeholder=""
                            value={row.accountCode}
                            onChange={(e) => handleRowChange(index, 'accountCode', e.target.value)}
                            readOnly={true} 
                          />
                        </td>
                        <td>
                            {(row.accountName || row.accountCode) ? (
                                <div className={row.direction === "Cr" ? classes.creditText : classes.debitText}>
                                {row.direction}
                                </div>
                            ) : null}
                        </td>
                        <td>
                          <input
                            type="number"
                            placeholder="0.00"
                            value={row.amount}
                            onChange={(e) => handleRowChange(index, 'amount', e.target.value)}
                            readOnly={(index === 0 || index === 1) && Boolean(totalAmount)} 
                          />
                        </td>
                        <td style={{textAlign: 'center'}}>
                          {rows.length > 1 && index !== 0 && index !== 1 && <button type="button" className={classes.removeRowBtn} onClick={() => removeRow(index)}>✕</button>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className={classes.modalFooter}>
            <div className={classes.footerSummaryRow}>
              <div className={classes.modalSummaryBox}>
                <p>Total Debit</p>
                <h4>{totalDebit.toLocaleString('en-NG', {minimumFractionDigits: 2})}</h4>
              </div>
              <div className={classes.modalSummaryBox}>
                <p>Total Credit</p>
                <h4>{totalCredit.toLocaleString('en-NG', {minimumFractionDigits: 2})}</h4>
              </div>
            </div>
            <div className={classes.modalBtnRow}>
              <button type="button" className={classes.modalBtn} onClick={handleReset}>Reset</button>
             <button
  type="button"
  className={classes.modalBtnPrimary}
  onClick={handleSubmit}
  disabled={isOverBalance || isSaving}
>
  {isSaving ? (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <Spinner animation="border" size="sm" />
      {mode === "approve" ? "Approving..." : "Saving..."}
    </span>
  ) : (
    mode === "approve" ? "Approve Request" : "Process Withdrawal"
  )}
</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

// --- Main Component ---
const SavingsWithdrawals = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [companyId, setCompanyId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openExcelModal, setOpenExcelModal] = useState(false); // Added state for Excel Modal
const [filterType, setFilterType] = useState("all");
const [showFilterMenu, setShowFilterMenu] = useState(false);

const [selectedWithdrawal, setSelectedWithdrawal] = useState(null);
const [modalMode, setModalMode] = useState("create");
  const [totalWithdrawal, setTotalWithdrawal] = useState(0);
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [totalMembers, setTotalMembers] = useState(0);

  const pageMap = { "/dashboard": "Dashboard", "/savings": "Savings", "/savings/withdrawals": "Savings Withdrawals" };

  useEffect(() => {
    const compInfo = localStorage.getItem('companyInfo');
    if (compInfo) {
      try {
        const parsedInfo = JSON.parse(compInfo);
        setCompanyId(parsedInfo.id);
      } catch (e) {
        console.error("Error parsing company info", e);
      }
    }
  }, []);

  const fetchWithdrawalsData = useCallback(async () => {
    if (!companyId) {
      setLoading(false);
      return;
    }
    
    setLoading(true);
    try {
      const res = await api.get('/v1/member/fetch-savings-withdrawal', { 
        params: { company_id: Number(companyId) } 
      });

      if (res.data?.status && res.data.data) {
        const { total_withdrawal, total_transactions, total_members, withdrawals } = res.data.data;
        setTotalWithdrawal(total_withdrawal || 0);
        setTotalTransactions(total_transactions || 0);
        setTotalMembers(total_members || 0);
        setWithdrawals(withdrawals?.data || []);
      } else {
        setWithdrawals([]);
        setTotalWithdrawal(0);
        setTotalTransactions(0);
        setTotalMembers(0);
      }
    } catch (error) {
      console.error("Failed to fetch savings withdrawals:", error);
      setWithdrawals([]);
      setTotalWithdrawal(0);
      setTotalTransactions(0);
      setTotalMembers(0);
    } finally {
      setLoading(false);
    }
  }, [companyId]);



const handleWithdrawalSuccess = useCallback(() => {
  setFilterType("all");   // Switch back to All Withdrawals
}, []);

  const fetchPendingWithdrawalRequests = useCallback(async () => {
  if (!companyId) return;

  setLoading(true);

  try {
    const res = await api.get(
      "/v1/pending_request_savings_withdrawal",
      {
        params: {
          company_id: Number(companyId),
        },
      }
    );

    if (res.data?.status) {
      setWithdrawals(res.data.data.withdrawals?.data || []);

      // optional if API returns summary
      setTotalWithdrawal(0);
      setTotalTransactions(res.data.data.withdrawals?.data?.length || 0);
      setTotalMembers(0);
    } else {
      setWithdrawals([]);
    }
  } catch (err) {
    console.log(err);
    setWithdrawals([]);
  } finally {
    setLoading(false);
  }
}, [companyId]);

useEffect(() => {

    if(filterType === "all"){
        fetchWithdrawalsData();
    }else{
        fetchPendingWithdrawalRequests();
    }

},[
    filterType,
    fetchWithdrawalsData,
    fetchPendingWithdrawalRequests
]);

  const mapStatus = (val) => {
    const map = {
      '0': 'Pending',
      '1': 'Pending Approval',
      '2': 'Approved',
      '3': 'Completed',
      '4': 'Paid'
    };
    return map[String(val)] || String(val);
  };

  const renderStatus = (value) => {
    if (!value) return <span className={classes.yellowStatus}>Pending</span>;
    const text = mapStatus(value);
    const lowerVal = text.toLowerCase();
    if (lowerVal === 'approved' || lowerVal === 'paid' || lowerVal === 'completed') 
      return <span className={classes.greenStatus}>{text}</span>;
    if (lowerVal === 'reversed' || lowerVal === 'failed') 
      return <span className={classes.redStatus}>{text}</span>;
    return <span className={classes.yellowStatus}>{text}</span>;
  };

  const handleReverseWithdrawal = async (item) => {
    const result = await Swal.fire({
      title: 'Reverse Withdrawal',
      text: 'Are you sure you want to reverse this transaction?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reverse it!'
    });
    if (!result.isConfirmed) return;
    
    try {
      const response = await api.post(`/v1/reverse-savings-withdrawal`, {
        withdrawal_id: item.id,
        company_id: companyId
      });
      
      if (response.status === 200 || response.status === 201) {
        setWithdrawals(withdrawals.filter(w => w.id !== item.id));
        Swal.fire({ title: 'Success!', text: 'Transaction reversed successfully.', icon: 'success', confirmButtonColor: '#3085d6' });
      }
    } catch (error) {
      Swal.fire({ title: 'Error!', text: error.response?.data?.message || 'Error reversing transaction.', icon: 'error', confirmButtonColor: '#3085d6' });
    }
  };

  const hasData = withdrawals.length > 0;
  const firstRecord = hasData ? withdrawals[0] : {};
  const hasPaymentStatus = 'payment_status' in firstRecord;
  const hasWithdrawalStatus = true;
  const hasPostDate = true;

  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname] || "Savings"} />
      <div className={classes.Container}>
        <header className={classes.Header}>
          <h2 className={classes.Title}>Savings Withdrawals</h2>
          <h1 className={classes.Titles}>Manage member savings withdrawals and payout records.</h1>
        </header>

        <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Withdrawals</p>
                <p className={classes.kdptg1}>
                  {loading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    totalWithdrawal.toLocaleString('en-NG', { minimumFractionDigits: 2 })
                  )}
                </p>
                <div className={classes.rvnue}><p className={classes.skaltxt}>This month</p></div>
              </div>
            </div>

            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Transaction</p>
                <p className={classes.kdptg2}>
                  {loading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    totalTransactions.toLocaleString()
                  )}
                </p>
                <div className={classes.rvnue}><p className={classes.skaltxt}>This month</p></div>
              </div>
            </div>

            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Members</p>
                <p className={classes.kdptg4}>
                  {loading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    totalMembers
                  )}
                </p>
                <div className={classes.rvnue}><p className={classes.skaltxt}>This month</p></div>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.headerActions}>
          {/* Left: Search Input */}
          <div className={classes.inputWrapper}>
            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
            <input type="text" className={classes.searchBar} placeholder="Search withdrawals..." />
          </div>

          {/* Right: Action Buttons Group */}

          <div className={classes.actionButtonsRight}>
            <div className={classes.filterWrapper}>

              <button
                  className={classes.filterBtn}
                  onClick={()=>setShowFilterMenu(!showFilterMenu)}
              >
                  <img src={filter} alt="" />
                  Filter
              </button>

              {
              showFilterMenu && (

              <div className={classes.filterMenu}>

              <div
              className={classes.filterItem}
              onClick={()=>{
                  setFilterType("all");
                  setShowFilterMenu(false);
              }}
              >
              All Withdrawals
              </div>

              <div
              className={classes.filterItem}
              onClick={()=>{
                  setFilterType("request");
                  setShowFilterMenu(false);
              }}
              >
              Withdrawal Requests
              </div>

              </div>

              )}

            </div>
            {/* ✅ Upload Excel Button - Moved here & updated text styling */}
            {filterType === "all" && (
            <div className={classes.buttonActions}>
              <button 
                className={classes.btnUploadExcel} 
                onClick={() => setOpenExcelModal(true)}
              >
                + Upload Excel
              </button>

              {/* New Withdrawal Button */}
              <button className={classes.btnss} onClick={() => setOpenModal(true)}>
                + New withdrawal
              </button>
            </div>
            )}
          </div>
        </div>

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                <th>S/N</th>
                {filterType === "all" && (
                <th>Withdrawal ID</th>
)}
                <th>Member Name</th>
                <th>Transaction Date</th>
                <th style={{ textAlign: 'right' }}>Amount</th>
                {hasPostDate && <th>Post Date</th>}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array(5).fill().map((_, idx) => <tr key={idx}>{Array(8).fill().map((_, i) => <td key={i}><Skeleton height={20} style={{ marginBottom: 10 }} /></td>)}</tr>)
              ) : withdrawals.length === 0 ? (
                <tr><td colSpan={8} style={{ textAlign: "center" }}>No savings withdrawals found.</td></tr>
              ) : (
                withdrawals.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    {
filterType === "all" && (
                    <td>{item.uuid}</td>
)}
                    <td>{item.member?.name || ""}</td>
                    <td>{item.transaction_date}</td>
                    <td style={{ textAlign: 'right' }}>
                      {Number(item.debit || item.amount).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
                    </td>
                    <td>
                      {item.created_at ? item.created_at.split("T")[0] : item.transaction_date}
                    </td>
                    <td className={classes.actions}>
                      {
filterType==="request" && (
                      <SquarePen
    size={16}
    className={classes.editIcon}
    style={{cursor:"pointer"}}
    onClick={()=>{
        setModalMode("approve");
        setSelectedWithdrawal(item);
        setOpenModal(true);
    }}
/>
)
}
                     
                      <Trash2 size={16} className={classes.deleteIcon} onClick={() => handleReverseWithdrawal(item)} style={{ cursor: "pointer" }} />
                      <Printer size={16} className={classes.printIcon} onClick={() => console.log("Printing", item)} style={{ cursor: "pointer" }} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button>First</button>
              <button className={classes.active}>1</button>
              <button>Last</button>
              <span className={classes.pageText}>Displaying 1 - {withdrawals.length} of {withdrawals.length}</span>
            </div>
          </div>
        </div>
      </div>

      
      
      {/* Modals */}
      <SavingsWithdrawalModal
    isOpen={openModal}
    onClose={() => {
  setOpenModal(false);
  setModalMode("create");
  setSelectedWithdrawal(null);
}}
    onSaveSuccess={handleWithdrawalSuccess}
    mode={modalMode}
    requestData={selectedWithdrawal}
/>
      
      <UploadExcelModal3
        isOpen={openExcelModal}
        onClose={() => setOpenExcelModal(false)}
        companyId={companyId}
        onUploadSuccess={handleWithdrawalSuccess}
      />
      
      <Footer />
    </div>
  );
};

export default SavingsWithdrawals;